import { Transfer } from '../../../types/transfer/Transfer';
import {
  INVENTORY_TRANSFER_DELETE,
  INVENTORY_ADVANCED_TRANSFER_SET_TRANSFERS,
  INVENTORY_ADVANCED_TRANSFER_ALL_TAB_REQUEST,
  INVENTORY_ADVANCED_TRANSFER_TAB_REQUEST,
  INVENTORY_TRANSFER_SET_FORM_TYPE,
  INVENTORY_ADVANCED_TRANSFER_REQUEST_EDIT,
  INVENTORY_ADVANCED_TRANSFER_EDIT,
  INVENTORY_ADVANCE_TRANSFER_CLOSE_FORM_DETAIL,
  ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_ITEM_TRANSFER,
  ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_INGREDIENT_TRANSFER,
  ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_ITEM_TRANSFER,
  ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_INGREDIENT_TRANSFER,
  INVENTORY_TRANSFER_ERROR_ITEM,
  ADVANCE_INVENTORY_TRANSFER_TAB_PERMISSION,
  INVENTORY_ADVANCE_TRANSFER_SUBMIT_SHIPMENT,
  INVENTORY_ADVANCE_TRANSFER_SUBMIT_FULFILLMENT,
  INVENTORY_ADVANCE_TRANSFER_FETCH_NEXT_PAGE,
} from './constants';

import type {
  Data as ItemTransferData,
  Activity as ItemTransferActivity,
} from '../../../api/inventory/advancedTransfer/types/common.types';
import type {
  Data as IngredientTransferData,
  Activity as IngredientTransferActivity,
} from '../../../api/ingredientInventory/advancedTransfer/types/responses';
import type { TransferTab } from '../../../reducers/inventory/types';
import type { FormType, TAB_TYPE } from '../../../types/actionBars';
import type {
  AdvancedTransferDeleteAction,
  AdvancedTransferFetchAllTabAction,
  AdvancedTransferFetchTabAction,
  AdvancedTransferRequestEditAction,
  AdvancedTransferSetFormTypeAction,
  AdvancedTransferSetListAction,
  DetailItemTransferAction,
  DetailIngredientTransferAction,
  PartialItemsTransferAction,
  PartialIngredientsTransferAction,
  AdvancedTransferEditAction,
  AdvancedTransferNextPageAction,
} from './types';

export function deleteTransfer(
  transferId: number,
  namespace: string
): AdvancedTransferDeleteAction {
  return {
    type: INVENTORY_TRANSFER_DELETE,
    payload: {
      transferId,
      namespace,
    },
  };
}

export function setAdvancedTransferList(
  data: TransferTab
): AdvancedTransferSetListAction {
  return {
    type: INVENTORY_ADVANCED_TRANSFER_SET_TRANSFERS,
    payload: {
      data,
    },
  };
}

export function setDetailItemTransfer(
  data: ItemTransferData
): DetailItemTransferAction {
  return {
    type: ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_ITEM_TRANSFER,
    payload: {
      data,
    },
  };
}

export function setDetailIngredientTransfer(
  data: IngredientTransferData
): DetailIngredientTransferAction {
  return {
    type: ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_INGREDIENT_TRANSFER,
    payload: {
      data,
    },
  };
}

export function setAdvancedTransferFormType(
  type: FormType
): AdvancedTransferSetFormTypeAction {
  return {
    type: INVENTORY_TRANSFER_SET_FORM_TYPE,
    payload: {
      type,
    },
  };
}

export function requestEditForm(
  namespace: string,
  transfer: Transfer
): AdvancedTransferRequestEditAction {
  return {
    type: INVENTORY_ADVANCED_TRANSFER_REQUEST_EDIT,
    payload: {
      namespace,
      transfer,
    },
  };
}

export function setPartialItemsTransfer(
  data: ItemTransferActivity[]
): PartialItemsTransferAction {
  return {
    type: ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_ITEM_TRANSFER,
    payload: {
      data,
    },
  };
}

export function setPartialIngredientsTransfer(
  data: IngredientTransferActivity[]
): PartialIngredientsTransferAction {
  return {
    type: ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_INGREDIENT_TRANSFER,
    payload: {
      data,
    },
  };
}

export function updateAdvancedInventory(
  namespace: string,
  id: number,
  transferItem: any
): AdvancedTransferEditAction {
  return {
    type: INVENTORY_ADVANCED_TRANSFER_EDIT,
    payload: {
      namespace,
      id,
      transferItem,
    },
  };
}

export function fetchAllTabTransferList(
  namespace: string,
  params: {
    start: string;
    end: string;
  },
  outletId?: string
): AdvancedTransferFetchAllTabAction {
  return {
    type: INVENTORY_ADVANCED_TRANSFER_ALL_TAB_REQUEST,
    payload: {
      namespace,
      params,
      outletId,
    },
  };
}

export function fetchTabTransferList(
  tabType: TAB_TYPE,
  namespace: string,
  params: {
    start: string;
    end: string;
    keyword?: string;
  },
  outletId?: string
): AdvancedTransferFetchTabAction {
  return {
    type: INVENTORY_ADVANCED_TRANSFER_TAB_REQUEST,
    payload: {
      tabType,
      namespace,
      params,
      outletId,
    },
  };
}

export function fetchNextPage(
  tabType: TAB_TYPE,
  namespace: string,
  outletId?: string | number
): AdvancedTransferNextPageAction {
  return {
    type: INVENTORY_ADVANCE_TRANSFER_FETCH_NEXT_PAGE,
    payload: {
      tabType,
      namespace,
      outletId,
    },
  };
}

export function closeFormDetail() {
  return {
    type: INVENTORY_ADVANCE_TRANSFER_CLOSE_FORM_DETAIL,
    payload: {},
  };
}

export function errorGetItem(payload) {
  return {
    type: INVENTORY_TRANSFER_ERROR_ITEM,
    payload,
  };
}

export function setTabPermission(payload) {
  return {
    type: ADVANCE_INVENTORY_TRANSFER_TAB_PERMISSION,
    payload,
  };
}

export function onSubmitShipment(namespace, rawParams, type) {
  return {
    type: INVENTORY_ADVANCE_TRANSFER_SUBMIT_SHIPMENT,
    payload: { namespace, rawParams, type },
  };
}

export function onSubmitFulfillment(
  namespace,
  rawParams,
  isLastFulfill: boolean
) {
  return {
    type: INVENTORY_ADVANCE_TRANSFER_SUBMIT_FULFILLMENT,
    payload: { namespace, rawParams, isLastFulfill },
  };
}
